import { DEBUG } from '@src/DEBUG'; 
DEBUG.open ( '/commons/FourDInjector.ts' );

import {Injector} from '@angular/core';

export class FourDInjector{
  static injector;
  constructor(public injector: Injector){
    DEBUG.log ( '/commons/FourDInjector.ts', 'CONSTRUCTOR static inject', injector );
    FourDInjector.injector = injector;
  }
}
